import { render } from "./TeamName.vue?vue&type=template&id=0a34d9dc"
import script from "./TeamName.vue?vue&type=script&lang=js"
export * from "./TeamName.vue?vue&type=script&lang=js"
script.render = render

export default script